import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-reveal";

export default function Skills(props) {
  const theme = props.theme;
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="skills-header" style={{ color: theme.text }}>
            About Me
          </h1>
          <p 
            style={{ color: theme.secondaryText, fontSize: '24px', letterSpacing: '3px', lineHeight: '1.5' }}
            >
            Hello, I'm Ethen, currently pursuing a Master's degree in Electrical and Computer Engineering 
            at the University of California, San Diego (UCSD). My research primarily focuses on 
            machine learning, computer vision, and robotics. During my graduate studies, I have taken courses such as 
            sensing and estimation, motion planning, and visual learning, where I learned about particle filters, visual-inertial SLAM, 
            model-free prediction/control, and advanced computer vision techniques. As an undergraduate student at the National Taiwan University (NTU), 
            I published two research papers on Face Anti-Spoofing (FAS) and Masked Face Recognition Systems in the field of deep learning in computer vision. 
            In addition to my academic achievements, I have 4+ years of experience in C++/Python programming. 
            I am passionate about exploring the intersection of these fields and excited to contribute to cutting-edge research and projects.
          </p>
          <h1 className="skills-header" style={{ color: theme.text }}>
            Interest
          </h1>
        </Fade>
      </div>
      <SkillSection theme={theme} />
    </div>
  );
}
